import axios from "axios";
import {Message} from "element-ui";
import router from "@/router";
import store from "@/store"
// import { BaseURL } from '@/settings.js';
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // 跨域请求时发送cookie
    timeout: 30000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么
        //请求添加token
        store.commit("SET_LOADING", true);
        config.headers["client_type"] = "H5";

        const language = localStorage.getItem("language") || "zh_cn";
        if (window.sessionStorage.getItem("accessToken")) {
            config.headers["access_token"] =
                window.sessionStorage.getItem("accessToken");
        }
        config.headers["language"] = language;
        return config;
    },
    (error) => {
        console.log(error); // for debug
        return;
    }
);

//响应拦截器
let f;
service.interceptors.response.use(
    (success) => {
        // 业务逻辑错误
        store.commit("SET_LOADING", false);
        if (success.status && success.status == 200) {
            if (success.data.code == 401) {
                if (f) return;
                f = true;
                Message.error(success.data.msg);
                localStorage.clear();
                sessionStorage.clear();
                router.push("/login");
                return;
            }
            if (success.data.code == 10000) {
                Message.error(success.data.msg);
                localStorage.clear();
                sessionStorage.clear();
                router.push("/login");
                return;
            }
        }
        return success.data;
    },
    (error) => {
        store.commit("SET_LOADING", false);
        if (error.response.data.code == 504 || error.response.data.code == 404) {
            Message.error("服务器被吃了o(╯□╰)o");
        } else if (error.response.data.code == 403) {
            Message.error("权限不足,请联系管理员!");
        } else if (error.response.data.code == 401) {
            // Message.error(error.response.data.msg);
            // router.replace('/login');
        } else {
            if (error.response.msg) {
                Message.error(message.response.data.msg);
            } else {
                Message.error("未知错误!");
            }
        }
        return;
    }
);

export default service;
